import { FC } from 'react'

import './NumpadDisplay.scss'

interface NumpadDisplayProps {
    value: string
    className?: string
}

export const NumpadDisplay: FC<NumpadDisplayProps> = ({ value, className = '' }) => (
    <div className={`numpad-display ${className}`}>
        {value}
    </div>
)
